import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { reduxForm, Field } from 'redux-form';
import { push } from 'react-router-redux';

import { MODALS, MESSAGING_URL } from 'global-constants';
import Button from 'shared/components/Button';
import { withModal } from 'shared/components/Modals';
import { default as Modal } from 'shared/components/Modals/GenericModal';

import renderTagInput from 'shared/forms/RenderTagInput';
import renderTextArea from 'shared/forms/RenderTextArea';
import renderInputFIeld from 'shared/forms/RenderInputField';

import { required } from 'shared/forms/validators';

import { sendMessages } from './ducks';

import styles from './styles.module.scss';

const FORM_NAME = 'sendMassMessageForm';

class SendMessagesModal extends React.Component {
  submit = data => {
    const extraActions = [
      () => this.props.push(MESSAGING_URL),
      () => this.props.closeModal()
    ];
    this.props.sendMessages(FORM_NAME, data, extraActions);
  };

  pasteSplit = data => {
    const separators = [',', ', ', ' '];
    return data.split(new RegExp(separators.join('|'))).map(d => d.trim());
  };

  render() {
    const { handleSubmit, invalid, submitting } = this.props;
    return (
      <Modal closeModal={this.props.closeModal}>
        <div className={styles.container}>
          <div className={styles.title}>Send mass message</div>
          <form onSubmit={handleSubmit(this.submit)}>
            <div className="form-group">
              <label className="form-label">Send as (user id)*</label>
              <Field
                name="author"
                validate={[required]}
                component={renderInputFIeld}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Send message to: (user ids)*</label>
              <Field
                name="broadcast_to"
                component={renderTagInput}
                onlyUnique={true}
                addOnPaste={true}
                pasteSplit={v => this.pasteSplit(v)}
                className={classnames('form-control', styles.broadcastWrapper)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Message content*</label>
              <Field
                name="content"
                validate={[required]}
                component={renderTextArea}
                className={styles.contentWrapper}
              />
            </div>
            <Button
              color="brand-green"
              className={styles.button}
              onClick={this.handleClick}
              disabled={invalid || submitting}
              type="submit">
              Send
            </Button>
          </form>
          <div className={styles.link} onClick={this.props.closeModal}>
            No thanks
          </div>
        </div>
      </Modal>
    );
  }
}

SendMessagesModal = reduxForm({ form: FORM_NAME })(SendMessagesModal);

const mapDispatchToProps = {
  sendMessages,
  push
};

export default connect(
  null,
  mapDispatchToProps
)(withModal(MODALS.SEND_MESSAGES_MODAL)(SendMessagesModal));
